
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.72 41.33h-5.61v-5.19c0-3-4.67-3-4.67 0v5.19h-5.61a2.34 2.34 0 000 4.67h5.61v6a2.34 2.34 0 004.67 0v-6h5.61a2.34 2.34 0 000-4.67zm30.63.42h-5.64a32.83 32.83 0 00-30.52-30.52V5.35c0-3-4.66-3-4.66 0v5.88A32.83 32.83 0 0011 41.75H5.38a2.33 2.33 0 000 4.66H11a32.83 32.83 0 0030.53 30.52v5.64a2.33 2.33 0 004.66 0v-5.64a32.83 32.83 0 0030.52-30.52h5.64a2.33 2.33 0 000-4.66zm-36.24 30.5v-5.49a2.34 2.34 0 00-4.67 0v5.49a28.25 28.25 0 01-25.83-25.84h5.49a2.33 2.33 0 000-4.66h-5.49a28.25 28.25 0 0125.83-25.84v5.24c0 3 4.67 3 4.67 0v-5.24A28.26 28.26 0 0172 41.75h-5.54a2.33 2.33 0 000 4.66H72a28.14 28.14 0 01-25.89 25.84z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    